import(/* webpackMode: "eager" */ "/home/runner/work/buildmind-watcher-ai/buildmind-watcher-ai/app/(default)/dashboard/robots/page.tsx")